export default __webpack_public_path__ + "assets/images/56385235eeed539f47d3b7a2dd1df427.png";